import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { CurrencyInput } from 'ui-components/components/currency-input';

import Global from '../../../../../../store/global-selectors';
import DeliveryOptionsItemPropType from '../delivery-option-item-prop-type';
import style from './edit-delivery-option-page.module.less';
import { DeliveryOptionsContext } from '../context';

export const FlatRateOptions = ({ flatRateValue = '', item, setItem }) => {
  const { contextMessages } = useContext(DeliveryOptionsContext);
  const sellerCurrencyCode = useSelector(Global.selectSellerDefaultCurrency);
  const onFlatRateInputChangeCallback = useCallback(
    (value) => {
      setItem({
        ...item,
        flatRate: {
          ...item.flatRate,
          code: sellerCurrencyCode,
          currency: sellerCurrencyCode,
          value: parseFloat(value),
          amount: parseFloat(value),
        },
      });
    },
    [item, sellerCurrencyCode, setItem],
  );
  return (
    <div className={style['edit-delivery-options-section']}>
      <div className={style['section-title']}>
        <FormattedMessage {...contextMessages.flatRatePrice} />
      </div>
      <div className={style['section-subtitle']}>
        <FormattedMessage {...contextMessages.flatRateDescription} />
      </div>
      <CurrencyInput
        className={style['currency-input']}
        currencyCode={sellerCurrencyCode}
        onChange={onFlatRateInputChangeCallback}
        onlyPositive
        showPlaceHolderForZero
        value={flatRateValue}
      />
    </div>
  );
};

FlatRateOptions.propTypes = {
  flatRateValue: PropTypes.number,
  item: DeliveryOptionsItemPropType.isRequired,
  setItem: PropTypes.func.isRequired,
};
